import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { yellow, blue } from '@material-ui/core/colors';

const theme = createMuiTheme({
  
    palette: {
      primary: blue,
      type: 'dark',
    },
    typography: {
      useNextVariants: true,
    },
  
  });

export default function CustomTheme(props) {

    return (<MuiThemeProvider theme={theme}>

        {props.children}

    </MuiThemeProvider>);


}

